<template>
    <div id="contents">
        <drm-auth />

        <div v-if="loadingStatus !== 'error'" class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- breadcrumbs -->
            <div v-bind:style="{ display: mode === 'search' ? 'block' : 'none', }">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w100">
                                <li class="tit_150">
                                    Country / Region
                                    <em class="txt_mandatory">*</em>
                                </li>
                                <li class="srch_a" data-input-type="input">
                                    <select
                                        name="countries"
                                        id="selectCountry"
                                        ref="selectCountry"
                                        class="slt_white w230p mr5"
                                        v-model="selectedCountry"
                                        @change="selectCountry($event)"
                                    >
                                        <option value="-">Select</option>
                                        <option
                                            v-for="item in availableCountryList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                    <span class="clearable w100-240">
                                        <!-- <span class="text_input">{{ selectedCountryListStr }}</span> -->
                                        <input
                                            type="text"
                                            id="txtSelectedCountryList"
                                            class="text_input"
                                            maxlength="300"
                                            :value="selectedCountryListStr"
                                            @keydown.prevent
                                            placeholder
                                            v-clearable:onClick="resetSelectedCountryList"
                                        />
                                    </span>
                                </li>
                            </ul>
                            <ul class="w100">
                                <li class="tit_150">Title</li>
                                <li class="srch_a" data-input-type="input">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w100"
                                            v-model="title"
                                            maxlength="100"
                                            v-clearable
                                        />
                                    </span>
                                </li>
                            </ul>
                            <ul class="w100">
                                <li class="tit_150">Added Date</li>
                                <li data-input-type="date">
                                    <fieldset class="ui_fieldset">
                                        <label class="date-wrap">
                                            <input
                                                id="fromDate"
                                                type="text"
                                                class="date_input w100"
                                                placeholder="From Date"
                                                maxlength="20"
                                                readonly
                                            />
                                            <a href="javascript:" class="in_btn" id="icoFromDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">Open Calendar</span>
                                            </a>
                                        </label>
                                        <div id="from-picker-container" />
                                        <em class="txt_space"></em>
                                        <label class="date-wrap">
                                            <input
                                                id="toDate"
                                                type="text"
                                                class="date_input w100"
                                                placeholder="To Date"
                                                maxlength="20"
                                                readonly
                                            />
                                            <a href="javascript:" class="in_btn" id="icoToDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">Open Calendar</span>
                                            </a>
                                        </label>
                                        <div id="to-picker-container" style="margin-top: -1px;" />
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Model</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        name="modelList"
                                        id="selectModelList"
                                        class="slt_white w100"
                                        v-if="modelFilterStatus == 'done'"
                                        v-model="selectedModel"
                                    >
                                        <option value="ALL">ALL</option>
                                        <option
                                            v-for="item in availableModelList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                    <select
                                        class="slt_white w230p"
                                        v-else-if="modelFilterStatus == 'loading'"
                                    >
                                        <option>LOADING...</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Type</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        name="contentList"
                                        id="selectContentList"
                                        class="slt_white w100"
                                        v-model="selectedContent"
                                    >
                                        <option value="ALL">ALL</option>
                                        <option
                                            v-for="item in availableContentList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49 clear">
                                <li class="tit_150">Buyer</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        name="buyerList"
                                        id="selectBuyerList"
                                        class="slt_white w100"
                                        v-if="buyerFilterStatus == 'done'"
                                        v-model="selectedBuyer"
                                    >
                                        <option value="ALL">ALL</option>
                                        <option
                                            v-for="item in availableBuyerList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                    <select
                                        class="slt_white w230p"
                                        v-else-if="buyerFilterStatus != 'loading'"
                                    >
                                        <option v-if="loading">LOADING...</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">SKU Code</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        name="skuCodeList"
                                        id="selectSkuCode"
                                        class="slt_white w100"
                                        v-model="selectedSkuCode"
                                    >
                                        <option value="ALL">ALL</option>
                                        <option
                                            v-for="item in availableSkuCodeList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                            </span>
                        </div>
                    </article>
                </div>

                <div>
                    <!-- Grid -->
                    <div class="grid_wrap">
                        <!-- Grid Count-->
                        <div class="grid_total">
                            Total Count
                            <em>{{ resultCount | numberFormat }}</em>
                        </div>
                        <!-- Grid "btn-->
                        <div class="btn_wrap">
                            <a
                                href="javascript:"
                                class="btn_white"
                                @click="onExcelDownloadClick"
                                title
                            >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                        </div>
                        <div id="grid">
                            <toast-grid
                                gridId="gridFindContent"
                                :key="gridKey"
                                :data="gridData"
                                :columns="gridColumns"
                                :options="gridOptions"
                                :pageOptions="gridPageOptions"
                                :theme="gridTheme"
                                :isTotalCount="false"
                                v-bind:click="contentClick"
                            />
                        </div>
                    </div>
                    <div class="paginate">
                        <sdl-pagination
                            :current-page="currentPage"
                            :total-rows="resultCount"
                            :per-page="perPage"
                            @change="search"
                            align="center"
                        />
                    </div>
                </div>
            </div>
            <div v-if="mode !== 'search'">
                <content-view v-if="viewData" :data="viewData" :encToken="encToken"></content-view>
                <!-- page btn -->
                <div class="btn_wrap_full topLine">
                    <a @click="mode = 'search'" class="btn_white size_full" title>List</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue            from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import $ from 'jquery';

import qs from 'query-string';
import moment from 'moment';
// import 'tui-date-picker/dist/tui-date-picker.css';
// import DatePicker from 'tui-date-picker';

import { SDLUtil, DateUtil } from '@/utils';

import DatePicker from '~c/DatePicker';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import DrmAuth from '~vb/certificate/DrmAuth';

import FindContentView from '~vb/anysvcmobile/findContent/FindContentView';

import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';

require('moment-jdateformatparser');

export default {
    name: 'anysvc-findcontent-list',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'content-view': FindContentView,
        'drm-auth': DrmAuth,
    },
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
            }),

            mode: 'search', // 'view'
            loadingStatus: 'loading', // 'done', 'error'
            searchStatus: 'done', // 'loading', 'disabled'

            modelFilterStatus: 'done',
            buyerFilterStatus: 'done',

            pageTitle: '',

            selectedCountry: '-',
            // node upgrade 20260908 ke01.liu
            nodeVersion: process.env.NODE_VERSION +" - ("+ process.env.NODE_ENV + ")  -  " + new Date() || 'unknown',

            selectedCountryList: [], // ['AF', 'AL', ...]
            selectedSkuCode: 'ALL',
            selectedContent: 'ALL',
            selectedModel: 'ALL',
            selectedBuyer: 'ALL',

            rangePicker: null,

            startDate: {},
            endDate: {},

            title: '',
            searchToAddDt: '',
            searchFromAddDt: '',

            availableCountryList: [], // [{'CODE_ID': 'AF', 'CODE_NAME': 'AFGHANISTAN'}, ...]
            availableContentList: [], // [{'CODE_ID': '..', 'CODE_NAME': '..'}, ...]
            availableFirstCategoryList: [], // [{'CODE_ID': '..', 'CODE_NAME': '..'}, ...]
            availableSkuCodeList: [], // [{'CODE_ID': '..', 'CODE_NAME': '..'}, ...]

            availableModelList: [], // [{'CODE_ID': '..', 'CODE_NAME': '..'}, ...]
            availableBuyerList: [], // [{'CODE_ID': '..', 'CODE_NAME': '..'}, ...]

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), //'Model',
                    name: 'NMMODEL',
                    width: 120,
                    align: 'left',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.TYPE'), //'Type',
                    name: 'TYPE',
                    width: 150,
                    align: 'left',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.BUYER'), //'Buyer',
                    name: 'BUYER_CODE',
                    width: 100,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SKUCODE'), //'SKU Code',
                    name: 'SKU_CODE',
                    width: 100,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE'),
                    name: 'TITLE',
                    align: 'left',
                    resizable: false,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DATE'), //'Date',
                    name: 'DTCREATE',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
            encToken: '',
            // gridPageOptions: {
            //     useClient: true,
            //     perPage: 3,
            // },
            selectRhqSubCd:'',
            hasFileDownloadAuth:''
        };
    },
    computed: {
        selectedCountryListStr() {
            const fullNameList = [];
            this.selectedCountryList.forEach(countryId => {
                const matched = this.availableCountryList.find(item => item.CODE_ID === countryId);
                fullNameList.push(matched.CODE_NAME);
            });

            return fullNameList.join(', ');
        },
    },
    created() {
        //console.log('FIND CONTENT CREATED');
    	if(undefined != $('#selectRhqSubCd :selected').val()){
    		this.selectRhqSubCd = $('#selectRhqSubCd :selected').val();
    	}
    },
    mounted() {
        // console.log('FIND CONTENT MOUNTED');
        if(undefined != $('#selectRhqSubCd :selected').val()){
    		this.selectRhqSubCd = $('#selectRhqSubCd :selected').val();
    	}
        this.initLoad();
        // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            (new moment()).add(-15, 'years').toDate(),
            (new moment()).toDate(),
        );
    },
    methods: {

        initLoad() {
            SDLUtil.showLoadingBar(true);
            console.log(' >>>>>>>>Node version (builtin)>>>>>>>>>>>> :', this.nodeVersion);          // v14.21.0
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/FindContent.skp`)
                    .then(resp => {
                        this.availableCountryList = resp.data.countryList;
                        this.availableContentList = resp.data.contentList;
                        this.availableSkuCodeList = resp.data.skuCodeList;
                        this.availableFirstCategoryList = resp.data.firstCategoryList;
                        //Type: only Hq admin or 090 auth show the item 'Product SW KNOX' and 'Product SW'
                        this.checkDownloadFileAuth();  
                        this.loadingStatus = 'done';
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        Vue.$log.error(err.response);
                        SDLUtil.showLoadingBar(false);
                        this.loadingStatus = 'error';
                    })
            );
        },

        loadModelByCountry() {
            this.modelFilterStatus = 'loading';
            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/selectModelInCountry.skp`, {
                    params: {
                        selectedCountry: this.selectedCountryList.join(','),
                    },
                })
                .then(resp => {
                    this.availableModelList = resp.data;
                    this.modelFilterStatus = 'done';
                })
                .catch(err => {
                    Vue.$log.error(err);
                    this.modelFilterStatus = 'error';
                });
        },

        loadBuyerByCountry() {
            this.buyerFilterStatus = 'loading';
            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/selectBuyerInCountry.skp`, {
                    params: {
                        selectedCountry: this.selectedCountryList.join(','),
                    },
                })
                .then(resp => {
                    // console.log('buyer', resp.data);
                    this.availableBuyerList = resp.data;
                    this.buyerFilterStatus = 'done';
                })
                .catch(err => {
                    Vue.$log.error(err);
                    this.modelFilterStatus = 'error';
                });
        },

        selectCountry(event) {
            if (event.target.selectedIndex === 0) return; // Selected value is Index 0.
            const idx = this.selectedCountryList.findIndex(countryCode => countryCode === event.target.value);
            if (idx > -1) return;
            this.selectedCountryList.push(event.target.value);

            this.loadModelByCountry();
            this.loadBuyerByCountry();
        },

        resetSelectedCountryList() {
            this.selectedCountryList = [];
            this.selectedCountry = '-';
            this.availableBuyerList = [];
            this.availableModelList = [];
        },

        validateSearchParams() {
            if (this.selectedCountryList.length === 0) {
                SDLUtil.alert({
                    msg: 'Please select at least one country to start search.',
                    onOkEvt: () => {
                        this.$refs.selectCountry.focus();
                    },
                });
                return false;
            }
            return true;
        },

        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            const format = moment().toMomentFormatString('MM.dd.yyyy');
            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(format) : '';

            const params = {
                page: pageNo,
                country: this.selectedCountryList.join(','),
                selectedCountry: this.selectedCountryList.join(','),
                selectedCountryNm: this.selectedCountryListStr,
                buyer: this.selectedBuyer,
                model: this.selectedModel,
                content: this.selectedContent,
                skucode: this.selectedSkuCode,
                title: this.title,
                searchFromAddDt,
                searchToAddDt,
                //hasFileDownloadAuth:this.hasFileDownloadAuth,
                corpNo:this.selectRhqSubCd == '' ? $('#selectRhqSubCd :selected').val():this.selectRhqSubCd,
            };

            if (exclude.length > 0) {
                exclude.forEach(item => {
                    if (item in params) delete params[item];
                });
            }

            Vue.$log.info('search params', params);
            return params;
        },

        search(pageNo) {
            if (!pageNo) pageNo = 1;

            if (!this.validateSearchParams()) return;

            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            // this.gridData = [];
            this.searchStatus = 'loading';
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/FindContentSearch.skp`,
                    qs.stringify(formData),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(resp => {
                    Vue.$log.info('SEARCH RESULT =>> ', resp);
                    this.resultCount = resp.data.count;
                    this.gridData = Object.assign([], resp.data.rows);


                    // Server에서 결과가 x개 미만일 때 항상 listRow을 돌려주는 문제를 해결하는 if문
                    if (typeof resp.data.rows !== 'undefined' &&
                        resp.data.rows.length === 0
                    ) {
                        this.resultCount = 0;
                    }

                    this.searchStatus = 'done';
                    this.loadingStatus = 'done';

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },

        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;
            this.fetchContent(event.rowKey);
        },

        fetchContent(rowIdx) {
            const item = this.gridData[rowIdx];
            Vue.$log.info('ITEM', item);
            SDLUtil.showLoadingBar(true);

            const data = {
                CTTID: item.CTTID,
                NMMODEL: item.NMMODEL,
                CDCODE: item.COUNTRY_CD,
                country_show_detail: item.COUNTRY_NM,
                buyer: item.BUYER_CODE,
                COUNTRY_NM: item.COUNTRY_NM,
                BUYER_CODE: item.BUYER_CODE,
                SKU_CODE: item.SKU_CODE,
                CTTTYPE: item.CTTTYPE,
            };

            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/FindContentDetail.skp`, { params: data })
                .then(resp => {
                    Vue.$log.info('DETAIL', resp.data);
                    this.encToken = resp.data.encToken;
                    const rows = Array.isArray(resp.data.rows) ? resp.data.rows : [resp.data.rows];
                    // Data from List need to be added to the Detail data
                    rows.forEach((v, i) => {
                        rows[i].CATEGORY = item.CTTTYPE;
                        rows[i].FILENAME = v.VNAME;
                        rows[i].CDCODE = item.COUNTRY_CD;
                        rows[i].COUNTRY_CD = item.COUNTRY_CD;
                        rows[i].COUNTRY_NM = item.COUNTRY_NM;
                        rows[i].SKU_CODE = item.SKU_CODE;
                        rows[i].BUYER = item.BUYER_CODE;
                        rows[i].BUYER_CODE = item.BUYER_CODE;
                    });

                    this.viewData = rows;
                    Vue.$log.info('VIEW DATA', this.viewData);
                    // console.log('VIEW DATA', this.viewData);
                    this.mode = 'view';
                    window.scrollTo(0, 0);
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
        },

        onExcelDownloadClick() {
            if (this.resultCount >= 5000) {
                SDLUtil.alert({
                    title: 'Warning',
                    msg: 'Up to 5,000 rows will be listed in Excel file.<br>' +
                         'You can continue, but the donwloaded excel file will only have 5,000 rows.',
                    okLabel: 'Download',
                    onOkEvt: () => {
                        this.excelDownload();
                    },
                });
            } else {
                this.excelDownload();
            }
        },

        excelDownload() {
            if (!this.validateSearchParams()) return;

            SDLUtil.showLoadingBar(true);

            const exclude = ['page', 'country', 'selectedCountryNm'];
            const data = this.prepSearchParams(this.currentPage, exclude);

            return axios
                .get(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/findContentExceldownload.skp?${qs.stringify(
                        data,
                    )}`,
                )
                .then(resp => {
                    Vue.$log.info(resp);
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.EXCEL_FILES.length > 0) {
                        SDLUtil.show(
                            ExcelDownloadPopup,
                            {
                                title: 'Excel Download - Mobile Find Content',
                                excelFiles: resp.data.excelFiles,
                            }, // component params
                            {
                                height: 'auto',
                            }, // dialog params
                        );
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
            // window.open(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/findContentExceldownload.skp?${params}`);
        },
        
        checkDownloadFileAuth(){
        	if(undefined != $('#selectRhqSubCd :selected').val()){
           		this.selectRhqSubCd = $('#selectRhqSubCd :selected').val();
           	}
               return axios
                   .get(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/checkDownloadFileAuth.skp`, {
                	   
                       params: {
                           corpNo:this.selectRhqSubCd == '' ? $('#selectRhqSubCd :selected').val():this.selectRhqSubCd,
                       },
                   })
                   .then(resp => {
                  	 this.hasFileDownloadAuth =  resp.data.hasAuth;   
                  	 if(this.hasFileDownloadAuth === "false"){
                         this.availableContentList = this.availableContentList.filter((item,index) => item.CODE_ID !== 'Product SW' && item.CODE_ID !== 'Product SW KNOX');
                     }
                  	 
                   })
                   .catch(err => {
                       Vue.$log.error(err);
                   });
          },
    },
};
</script>

<style>
.zindex9999 {
    z-index: 9999;
}
#txtSelectedCountryList {
    background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/findContent/FindContent.vue